import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import { PostNode } from "../markdown-remark-types"

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date
      }
    }
  }
`

interface MarkdownRemarkNode {
  markdownRemark: PostNode
}

interface BlogPostProps {
  data: MarkdownRemarkNode
}

export default (props: BlogPostProps) => {
  const post = props.data.markdownRemark
  return (
    <Layout>
      <div>
        <h1>{post.frontmatter.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
      </div>
    </Layout>
  )
}
